import { Box, BoxProps, Typography } from '@mui/material';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { SequencedIngredientOrGroup } from '../../models/ingredient';
import { getIngredientsAndGroupsListItems } from '../../utils/ingredient/ingredient-utils';
import {
  IngredientGroupOrderIngredientGroupEnum,
  LabelCustomization,
} from '../../api';

interface IngredientListProps {
  ingredientsAndGroups: SequencedIngredientOrGroup[];
  flexibleGroups: IngredientGroupOrderIngredientGroupEnum[];
  inPreview?: boolean;
  containerProps?: BoxProps;
  labelCustomization?: LabelCustomization;
}

const IngredientList: React.FC<IngredientListProps> = ({
  ingredientsAndGroups,
  flexibleGroups,
  inPreview,
  containerProps,
  labelCustomization,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const ingredientsAndGroupsListItems = getIngredientsAndGroupsListItems(
    ingredientsAndGroups,
    flexibleGroups,
    t,
    language
  );
  const flatListItems = ingredientsAndGroupsListItems.flat();
  const hasAnyOrganic = flatListItems.some((item) => item.isOrganic);

  return (
    <Box p={2} {...containerProps}>
      <Typography fontFamily="inherit">
        {inPreview && <b>{t('common.ingredients')}: </b>}
        {flatListItems.map((listItem, index) => {
          return (
            <Fragment key={listItem.text + index}>
              {index !== 0 && !listItem.isGrouped && !listItem.isSub && ', '}
              <Typography
                component="span"
                fontFamily="inherit"
                fontWeight={listItem.isBold ? 'bold' : 'normal'}
                key={listItem.text}
              >
                {listItem.text}
              </Typography>
              {listItem.isOrganic && (
                <Typography
                  component="sup"
                  fontFamily="inherit"
                  variant="caption"
                >
                  **
                </Typography>
              )}
            </Fragment>
          );
        })}
        {
          <Typography component="span" fontFamily="inherit">
            {'.'}
          </Typography>
        }
      </Typography>
      {!inPreview && !!labelCustomization?.enableIngredientLegend && (
        <Typography textAlign="right" variant="body2" fontFamily="inherit">
          *{t('winefo-point.allergen')}
        </Typography>
      )}
      {!inPreview && hasAnyOrganic && (
        <Typography textAlign="right" variant="body2" fontFamily="inherit">
          **{t('winefo-point.organic')}
        </Typography>
      )}
    </Box>
  );
};

export default IngredientList;
